import { render, staticRenderFns } from "./AdminGliderFilter.vue?vue&type=template&id=60100e10"
import script from "./AdminGliderFilter.vue?vue&type=script&lang=ts"
export * from "./AdminGliderFilter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports